export const COPY_SUCCESS = "Your Password has been copied successfully";
export const ALERT = "You need to Select at least one option";
